let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("6dvCu"), load("u2Avf"), load("4CFMq"), load("kiHEA")]).then(() => parcelRequire('79yMH'));